import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const.js'

const GET_NATIONALITY_NAME_BY_CODE = (nationCode) => {
  let name = ''
  const compCode = nationCode ? nationCode.toUpperCase() : ''
  CONST.COUNTRY.some((c) => {
    if (c.code === compCode) {
      name = c.name
      return true
    }
    return false
  })
  return name
}

const state = {
  licensorObject: {},
  selectedLicensor: {},
}

const getters = {
  licensorList: state => {
    const list = []
    if (!isEmpty(state.licensorObject) && state.licensorObject.items.length > 0) {
      state.licensorObject.items.forEach((licensor) => {
        const info = []
        info.id = licensor.id
        info.licensorName = `${licensor.family_name} ${licensor.given_name}`
        info.company = licensor.company
        info.currency = licensor.currency ? licensor.currency.toUpperCase() : ''
        info.email = licensor.user.email
        list.push(info)
      })
    }
    return list
  },
  getSelectedLicensorInfo: state => {
    const data = []
    if (!isEmpty(state.selectedLicensor)) {
      const info = {}
      info.id = state.selectedLicensor.id
      info.email = state.selectedLicensor.user.email
      info.licensorName = `${state.selectedLicensor.family_name} ${state.selectedLicensor.given_name}`
      info.company = state.selectedLicensor.company
      info.currency = state.selectedLicensor.currency ? state.selectedLicensor.currency.toUpperCase() : ''
      info.fee = ''
      info.nationality = GET_NATIONALITY_NAME_BY_CODE(state.selectedLicensor.nationality)
      info.mimsAccount = state.selectedLicensor.mims_account
      const feeKr = state.selectedLicensor.default_service_fee_kr
      const feeOther = state.selectedLicensor.default_service_fee_other
      info.fee = `한국 ${feeKr}% / 해외 ${feeOther}%`
      data.push(info)
    }
    return data
  },
  getSelectedLicensorId: state => {
    let targetId = null
    if (!isEmpty(state.selectedLicensor)) targetId = state.selectedLicensor.id
    return targetId
  },
  licensorListTotalCount: state => {
    let count = 0
    if (!isEmpty(state.licensorObject)) count = state.licensorObject.filtered
    return count
  },
  getArtistList: state => {
    return state.selectedLicensor.artists
  },
}

const mutations = {
  INIT_STORE (state) {
    state.licensorObject = {}
    state.selectedLicensor = {}
  },
  SET_LICENSOR_LIST (state, payload) {
    state.licensorObject = payload
  },
  SET_SELECTED_LICENSOR (state, licensorId) {
    state.licensorObject.items.some((licensor) => {
      if (licensor.id === licensorId) {
        state.selectedLicensor = licensor
        return true
      }
      return false
    })
  },
  SET_QUERY_LICENSOR (state, payload) {
    state.selectedLicensor = payload
  },
}

const actions = {
  clearInitStore ({ commit }) {
    commit('INIT_STORE')
  },
  queryLicensor ({ commit }, param) {
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: '/licensor',
        params: param,
      }).then((res) => {
        commit('SET_LICENSOR_LIST', res.data)
        resolve(res)
      }).catch((err) => {
        commit('SET_LICENSOR_LIST', {})
        reject(err)
      })
    })
  },
  setSelectedLicensor ({ commit }, licensorId) {
    commit('SET_SELECTED_LICENSOR', licensorId)
  },
  queryLicensorById ({ commit }, licensorId) {
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: `/licensor/${licensorId}`,
      }).then((res) => {
        commit('SET_QUERY_LICENSOR', res.data)
        resolve('ok')
      }).catch((err) => {
        commit('SET_QUERY_LICENSOR', {})
        reject(err)
      })
    })
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
